import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseApiService } from './base-api.service';

/**
 * Queue API Service
 */
@Injectable({
    providedIn: 'root'
})
export class QueueService extends BaseApiService {

    /**
     * Get queue status
     */
    getQueueStatus(): Observable<any> {
        return this.get<any>('/queue/status')
            .pipe(map(response => response.data!));
    }

    /**
     * Get queue items
     */
    getQueueItems(): Observable<any> {
        return this.get<any>('/queue/items')
            .pipe(map(response => response.data!));
    }
}
